import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import trim from 'lodash/trim';
import {
	SdfAlert,
	SdfInput,
	SdfSelectSimple
} from "@synerg/react-components";
import { countryList } from './countryList';

export default function CreateCertificateForm({ orgName, email }) {
	const { control, setValue } = useFormContext({
		commonName: '',
		organizationName: '',
		organizationUnit: '',
		countryObj: '',
		state: '',
		locality: '',
		email: ''
	});

	useEffect(() => {
		if (orgName) {
			setValue('organizationName', orgName);
		}
		if (email) {
			setValue('email', email);
		}
	}, [orgName, email]);

	const validateEmail = {
		empty: value => trim(value).length > 0 || 'Business email cannot be empty',
		email: value => RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(value) || 'Business email should be in correct format'
	};

	const ShowError = ({ message }) => {
		return (
			<SdfAlert
				slot="alert"
				size="sm"
				status="error"
				type="inline"
			>
				{message}
			</SdfAlert>
		);
	};

	return (
		<div className="mt-5 lg:w-2/4 md:w-full flex flex-col">
			<Controller
				name="commonName"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'Certificate name cannot be empty'
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfInput
						name="commonName"
						label="Name your certificate (e.g. My Mutual SSL)"
						className="mt-5"
						rows={4}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
						value={value}
						state={error ? 'error' : 'normal'}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
			<Controller
				name="organizationName"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'Organization name cannot be empty'
				}}
				render={({
					field: { value },
					fieldState: { error },
				}) => (
					<SdfInput
						disabled={true}
						name="organizationName"
						label="Organization name"
						className="mt-5"
						rows={4}
						value={value}
						state={error ? 'error' : 'normal'}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
			<Controller
				name="organizationUnit"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'Organization unit name cannot be empty'
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfInput
						name="organizationUnit"
						label="Organization unit name (e.g. HR, IT, etc.)"
						className="mt-5"
						rows={4}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
						value={value}
						state={error ? 'error' : 'normal'}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
			<Controller
				name="countryObj"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'Country cannot be empty'
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfSelectSimple
						name="countryObj"
						label="Country"
						className="mt-5"
						rows={4}
						items={countryList.map((c) => {
							return { label: c.countryName, value: c.countryCode };
						})}
						state={error ? 'error' : 'normal'}
						value={value}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfSelectSimple>
				)}
			/>
			<Controller
				name="state"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'State/Province name cannot be empty'
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfInput
						name="state"
						label="State/Province name"
						className="mt-5"
						rows={4}
						state={error ? 'error' : 'normal'}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
						value={value}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
			<Controller
				name="locality"
				control={control}
				rules={{
					validate: value => trim(value).length > 0 || 'Locality (e.g. City) cannot be empty'
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfInput
						name="locality"
						label="Locality (e.g. City)"
						className="mt-5"
						rows={4}
						value={value}
						state={error ? 'error' : 'normal'}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
			<Controller
				name="email"
				control={control}
				rules={{
					validate: validateEmail
				}}
				render={({
					field: { value, onChange },
					fieldState: { error },
				}) => (
					<SdfInput
						name="email"
						label="Business email"
						className="mt-5"
						rows={4}
						value={value}
						state={error ? 'error' : 'normal'}
						disabled={email ? true : null}
						onSdfChange={({ detail }) => {
							onChange(detail);
						}}
					>
						{error && error.message && <ShowError message={error.message} />}
					</SdfInput>
				)}
			/>
		</div>
	)
}
